import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import "./index.css";
import AppBridge from "../../../utils/appBridge";
import { store } from "../../../store";
class Index extends Component {
  state = {
    //页面动作
    src:''
  };

  //进入页面调用接口
  componentDidMount() {
    if (AppBridge && AppBridge.exist()) {
      AppBridge.setTitleBar("Recommended Apps", "");
      
    }
    let person = store.getState().languageReducer.subScriptData;
    if (person) {
      this.setState({
        src:'https://aio-apps.channelwill.com/?shopify_domain='+person.domain+'&app=518111167166087168&shopify_polaris=12.1.1'
      })
    }
  }

  render() {

    const {src } = this.state;

    const pageContent = (
        <iframe className="h-screen w-full border-none" title="reeecommended-apps" src={src} ></iframe>
    );

    return (
      <div style={{ background: 'rgb(241, 241, 241)' }}>
        {/* 页面内容 */}

        {pageContent}
      </div>
    );
  }
}

export default withRouter(Index);
